<template>
  <div :class="['sk', variant]" role="status" aria-live="polite">
    <span class="pb-sr-only">{{ label }}</span>
    <div v-for="n in rows" :key="n" class="sk-item" aria-hidden="true">
      <span class="pb-skeleton sk-a"></span>
      <span class="sk-lines"><span class="pb-skeleton sk-b"></span><span class="pb-skeleton sk-c"></span></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SkeletonList',
  props: {
    rows: { type: Number, default: 6 },
    variant: { type: String, default: 'rows' },
    label: { type: String, default: 'Loading…' }
  }
};
</script>

<style scoped>
.sk-item{display:flex;align-items:center;gap:14px;padding:16px;border:1px solid #EFE9E0;border-radius:14px;background:#fff;margin-bottom:10px}
.sk-a{width:40px;height:40px;border-radius:50%;flex:0 0 40px}
.sk-lines{flex:1;display:flex;flex-direction:column;gap:8px}
.sk-b{height:12px;width:38%}
.sk-c{height:12px;width:72%}
.sk.tiles{display:grid;grid-template-columns:repeat(auto-fill,minmax(min(200px,100%),1fr));gap:14px}
.sk.tiles .sk-item{margin:0;height:96px}
</style>
